import HoldingsSection from "./holdings-section";

export default HoldingsSection;
